var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.025,11.634A12.9,12.9,0,0,0,11.583,4.5,12.9,12.9,0,0,0,.14,11.635a1.3,1.3,0,0,0,0,1.174,12.9,12.9,0,0,0,11.443,7.134,12.9,12.9,0,0,0,11.443-7.135A1.3,1.3,0,0,0,23.025,11.634ZM11.583,18.013a5.791,5.791,0,1,1,5.791-5.791A5.791,5.791,0,0,1,11.583,18.013Zm0-9.652a3.833,3.833,0,0,0-1.018.152A1.924,1.924,0,0,1,7.874,11.2a3.852,3.852,0,1,0,3.708-2.843Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.25afbd801f2be561f75eb831ef21ca59.svg";
export { ForwardRef as ReactComponent };